'use strict';
import { YouTubeApi } from './youtube-api';
import { SelectAppointment } from './appointments/_select-appointment/select-appointment';
import { MenstrualCycleForm } from './appointments/_forms/menstrual-cycle-form';
import { Analytics } from './analytics';
import moment from 'moment';
import AlertModal from './appointments/alert-modal';

export class PhysiciansDetails {
    constructor() {
        this.container = document.querySelector('main.physician-page');
        if (!this.container) {
            return;
        }
        this.analytics = new Analytics(false);
        this.physicianId = this.container.querySelector('section.physician-single').dataset.physicianId;

        this.queryElements();

        this.setupDetailsPartsANavigation();
        this.setupDetailsPartsBNavigation();

        this.setupEditorialShowLessShowMore();
        this.setupCommentsShowLessShowMore();

        this.setupCareTeamEventListeners();

        this.mentrualCycleForm = new MenstrualCycleForm(_ => { });

        if (document.querySelector('.service-videos-section')) {
            this.player = new YouTubeApi();
        }

        if (document.querySelector('.ratings-container')) {
            this.jumpToRatings();
        }

        // this stack (a FIFO structure) is a list of functions that ought to be executed in the FIFO fashion: first in, first out
        // stacked items should be functions that when executed in the stack order will go back one step at a time for the widget
        this.backLinkLogicStack = [];
        this.backLinkDomElement = this.container.querySelector('#backArrow');
        if (this.backLinkDomElement) {
            this.backLinkDomElement.addEventListener('click', _ => {          
                if (this.backLinkLogicStack.length > 0) {
                    this.backLinkLogicStack.pop()();
                    document.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);
                }
            });
        }

        this.setupOnlineSchedulingModule();

        // going back in the flow can cause multiple click listeners firing off
        // the *better* approach would be to use the removeEventListener functions
        // but for expediency we can just detect the duplicates and not add them to the stack
        this.backLinkLogicStack.push = e => {
            if (!e) {
                return;
            }
            // do not push duplicates
            let dupFound = false;
            this.backLinkLogicStack.forEach(fn => {
                if (fn.toString() == e.toString()) {
                    dupFound = true;
                    return;
                }
            })

            if (dupFound === false) {
                Array.prototype.push.call(this.backLinkLogicStack, e);
            }
        };
    }

    setupCareTeamEventListeners() {
        const physicianCards = document.querySelectorAll('.careTeam div.physician-link')
        physicianCards.forEach((card) => {
            let url = card.dataset.physicianUrl;
            card.addEventListener('click', () => {
                window.location = url;
            })
        })
    }

    queryElements() {
        this.navItemGeneralInfo = this.container.querySelector('.details-navigation .nav-item.general-info');
        this.navItemVideo = this.container.querySelector('.details-navigation .nav-item.video');
        this.navItemHospitalAffiliations = this.container.querySelector('.details-navigation .nav-item.hospital-affiliations');

        this.detailsGeneralInfo = this.container.querySelector('.details.general-info');
        this.detailsVideo = this.container.querySelector('.details.video');
        this.detailsHospitalAffiliations = this.container.querySelector('.details.hospital-affiliations');

        this.navItemEducation = this.container.querySelector('.details-navigation .nav-item.education');
        this.navItemEditorial = this.container.querySelector('.details-navigation .nav-item.editorial');
        this.navItemPublications = this.container.querySelector('.details-navigation .nav-item.publications');
        this.navItemResearch = this.container.querySelector('.details-navigation .nav-item.research');

        this.detailsEducation = this.container.querySelector('.details.education');
        this.detailsEditorial = this.container.querySelector('.details.editorial');
        this.detailsPublications = this.container.querySelector('.details.publications');
        this.detailsResearch = this.container.querySelector('.details.research');
    }

    setupLastMenstrualCycleFieldListeners() {
        let container = document.querySelector('.last-menstrual-cycle-prompt');
        this.monthField = container.querySelector(".mdc-text-field__input[name='last_menstrual_cycle_month']");
        this.dayField = container.querySelector(".mdc-text-field__input[name='last_menstrual_cycle_day']");
        this.yearField = container.querySelector(".mdc-text-field__input[name='last_menstrual_cycle_year']");
        // toISOString is needed to prevent future deprecation issues
        let todayDate = moment(new Date().toISOString());

        this.monthField.addEventListener("keyup", ({ target }) => {
            target.value = target.value.replace(/\D/g, '');
            this.validateCycleForm(this.monthField, this.dayField, this.yearField, todayDate);

            // skip to the next field
            if (this.monthField.value.length == 2) {
                this.dayField.select();
            }
        });

        this.dayField.addEventListener("keyup", ({ target }) => {
            target.value = target.value.replace(/\D/g, '');
            this.validateCycleForm(this.monthField, this.dayField, this.yearField, todayDate);

            // skip to the next field
            if (this.dayField.value.length == 2) {
                this.yearField.select();
            }
        });

        this.yearField.addEventListener("keyup", ({ target }) => {
            target.value = target.value.replace(/\D/g, '');
            this.validateCycleForm(this.monthField, this.dayField, this.yearField, todayDate);
        });
    }

    validateCycleForm(monthField, dayField, yearField, todayDate) {
        this.submittedDate = new Date().getFullYear() - 200 && moment(`${monthField.value.padStart(2, '0')}/${dayField.value.padStart(2, '0')}/${yearField.value.padStart(4, '0')}`).toISOString();
        this.timePassed = todayDate.diff(this.submittedDate, 'days');
        this.mentrualCycleForm.validate(this.submittedDate, todayDate, yearField, '.last-menstrual-cycle-prompt');
    }

    setupChoosePatientModal() {
        const choosePatientModal = document.querySelector('.modal.choose-patient-prompt')
        if (!choosePatientModal) {
            return
        }
        const form = choosePatientModal.querySelector('form')
        form.addEventListener('submit', (e) => {
            e.preventDefault()
            const value = parseInt(e.submitter.value)
            if (value > 0) {
                choosePatientModal.classList.add('hidden')
            } else {
                if (this.date_of_birth_day) {
                    this.date_of_birth_day.value = null;
                    this.date_of_birth_month.value = null;
                    this.date_of_birth_year.value = null;
                }
                choosePatientModal.classList.add('hidden');
            }
        })
    }

    setupOnlineSchedulingModule(resetData = true) {
        if (resetData) {
            this.newPatient = null;
            this.establishedPatient = null;
            this.followUpVisit = null;
            this.hospitalFollowUpVisit = null;
            this.isPregnant = null;
            this.date_of_birth_day = null;
            this.date_of_birth_month = null;
            this.date_of_birth_year = null;
            this.dob = null;
            this.age = null;
        }
        this.ruledOut = null;

        this.setupDobFieldListeners();
        this.setupChoosePatientModal();
        this.setupNewPatientPrompt();
        this.setupFollowUpPrompt();
        this.setupVeinClinicPrompt();
        this.setupFullBodySkinExamPrompt();
        this.setupPrimaryCarePrompt();
        this.setupRuleOutQuestionsPerService();
        this.setupMedicareAdvantagePrompt();

        // on desktop, the scheduling right rail is set an position: absolute
        // this can cause a UI issue if the rain height is > than the rest of the physician page and overlap the footer
        // we want to dynamically increase the height of the page so that the right rail never overlaps the footer
        this.appointmentsRightRailElement = document.querySelector(".next-available-appointments-container");
        this.mainContainerElement = document.querySelector(".physician-single");
        let lastMargin = 0;
        if (this.appointmentsRightRailElement !== null) {
            // as the users interact with the right rail, it will change its height asynchronously (e.g. when loading data)
            // periodically resize the page if needed
            setInterval(_ => {
                const diff = this.mainContainerElement.offsetHeight - this.appointmentsRightRailElement.offsetHeight;

                if (diff < 0) {
                    // skip re-paint if no changes are detected
                    if (Math.abs(diff) !== lastMargin) {
                        lastMargin = Math.abs(diff);
                        this.mainContainerElement.style.marginBottom = `${lastMargin}px`;
                    }
                }
            }, 50);
        }
    }

    setupServiceReasonForVisitPrompt() {
        const radios = this.container.querySelectorAll('.reason-for-visit-prompt input[type="radio"]');
        const form = this.container.querySelector('.reason-for-visit-prompt form');
        this.reasonForVisitId = null;
        radios.forEach((radio) => {
            radio.addEventListener('change', (e) => {
                if (parseInt(radio.value)) {
                    this.reasonForVisitId = parseInt(radio.value);
                    this.showSchedulingPrompt();
                } else {
                    form.querySelector('[name="date_of_birth_day"]').value = this.date_of_birth_day.value;
                    form.querySelector('[name="date_of_birth_month"]').value = this.date_of_birth_month.value;
                    form.querySelector('[name="date_of_birth_year"]').value = this.date_of_birth_year.value;
                    form.querySelector('[name="appointment_new_patient_visit"]').value = this.newPatient;
                    form.querySelector('[name="appointment_established_patient_visit"]').value = this.establishedPatient;
                    form.querySelector('[name="appointmentServiceIds[]"]').value = this.selectedServiceId;
                    form.submit();
                }
            })
        })
    }

    setupSelectServicePrompt() {
        this.container.querySelector('.select-service-prompt').classList.remove('hidden');
        const serviceButtons = this.container.querySelectorAll('.select-service-prompt input');
        let filteredButtons = Array.from(serviceButtons).filter((e) => !e.classList.contains('follow-up-input'));

        // add a "back" function to the back link logic stack only if more than one specialty
        if (filteredButtons.length > 1) {
            this.backLinkLogicStack.push(_ => {
                document.querySelector('.dobPhysicians').classList.remove('hidden');
                this.backLinkDomElement.classList.add('hidden');
                this.container.querySelector('.select-service-prompt').classList.add('hidden');
            });
        }

        const handleServiceSelected = (target) => {
            let parent = target.closest('.ctas');
            let childNeeded = parent.querySelector(`[data-serviceid="${this.selectedServiceId}"]`);

            if (childNeeded.dataset.serviceIdMinimumAge > this.age || childNeeded.dataset.serviceIdMaximumAge < this.age) {
                document.querySelector('.age-restriction-modal').classList.remove('hidden');
            }

            this.container.querySelector('.select-service-prompt').classList.add('hidden');
            this.container.querySelector('.new-patient-prompt').classList.remove('hidden');

            // add a "back" function to the back link logic stack
            this.backLinkLogicStack.push(_ => {
                this.selectedServiceId = null;
                if (filteredButtons.length > 1) {
                    // provider has more than one specialty we must see select-service-prompt
                    this.container.querySelector('.select-service-prompt').classList.remove('hidden');
                } else {
                    // if provider only has one filterButton than we do not need to display it to the user
                    this.container.querySelector('.dobPhysicians').classList.remove('hidden');
                    this.backLinkDomElement.classList.add('hidden');
                }
                this.container.querySelector('.new-patient-prompt').classList.add('hidden');
            });
        }

        serviceButtons.forEach((button) => {
            button.addEventListener("click", ({ target }) => {
                this.selectedServiceId = target.value;
                const modal = this.container.querySelector(`.alertModal[data-service-id="${this.selectedServiceId}"]`);
                if (modal) {
                    const alertModal = new AlertModal(
                        modal,
                        () => handleServiceSelected(target),
                        () => {
                            this.container.querySelector(".select-service-prompt").classList.add("hidden");
                            this.container.querySelector('.dobPhysicians').classList.remove('hidden');
                        }
                    );
                    alertModal.show();
                    return;
                }
                handleServiceSelected(target);
            });
        });
          

        // if only one service is schedulable, click it for the user to reduce the number of steps they need to take
        if (filteredButtons.length == 1) {
            filteredButtons[0].click();
        }
    }

    setupPregnancyPrompt() {
        const isPregnantBtn = this.container.querySelector("#patient-is-pregnant");
        const isNotPregnantBtn = this.container.querySelector("#patient-is-not-pregnant");
        if (isPregnantBtn != undefined && isNotPregnantBtn != undefined) {
            [isPregnantBtn, isNotPregnantBtn].forEach(button => button.addEventListener('click', ({ target }) => {
                this.container.querySelector('.ask-if-pregnant-prompt').classList.add('hidden');
                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    this.isPregnant = null;
                    this.container.querySelector('.ask-if-pregnant-prompt').classList.remove('hidden');
                });
                if (target === isPregnantBtn) {
                    this.isPregnant = true;
                    this.showMenstralCyclePrompt();
                } else if (target === isNotPregnantBtn) {
                    this.isPregnant = false;
                    this.showSchedulingPrompt();
                }
            }));
        }
    }

    showMenstralCyclePrompt() {
        if (this.container.querySelector('.last-menstrual-cycle-prompt')) {
            this.setupLastMenstrualCycleFieldListeners();
            const form = this.container.querySelector('.last-menstrual-cycle-prompt');
            const btn = this.container.querySelector('#submit-last-menstrual-date');
            form.classList.remove('hidden');

            btn.addEventListener('click', (e) => {
                this.determineIfValidDate(form);
            })
        }
    }

    determineIfValidDate(form) {
        if (this.timePassed && this.submittedDate) {
            form.classList.add('hidden');
            // 224 days == 32 weeks
            if (this.timePassed > 224) {
                this.showCongratsMessage();
            } else if (this.timePassed < 56) {
                // 56 days == 8 weeks
                let startAvailableTimesOnDate = moment(this.submittedDate).add(56, 'days');
                document.querySelector(".select-appointment-content").classList.remove('hidden');
                new SelectAppointment(this.physicianId, 5, this.selectedServiceId, this.newPatient, this.establishedPatient, this.followUpVisit, startAvailableTimesOnDate);
            } else {
                this.showSchedulingPrompt();
            }
        }
    }

    showCongratsMessage() {
        if (document.querySelector('.pregnancy-congrats-message')) {
            document.querySelector('.last-menstrual-cycle-prompt').classList.add('hidden');
            document.querySelector('.pregnancy-congrats-message').classList.remove('hidden');
        }
    }

    setupPrimaryCarePrompt() {
        const isHospitalFollowUp = this.container.querySelector("#hospital-follow-up-visit");
        const notHospitalFollowUp = this.container.querySelector("#not-hospital-follow-up-visit");

        if (!isHospitalFollowUp || !notHospitalFollowUp) {
            return;
        }

        [isHospitalFollowUp, notHospitalFollowUp].forEach(button => button.addEventListener('click', ({ target }) => {
            const hospitalFollowupPrompt = this.container.querySelector('.hospital-followup-prompt');
            if (target === isHospitalFollowUp) {
                this.hospitalFollowUpVisit = true;

                hospitalFollowupPrompt.classList.add('hidden');
                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    // it is possible that the DOM elements were recreates, so we need to query for this again
                    const hospitalFollowupPrompt = this.container.querySelector('.hospital-followup-prompt');
                    this.hospitalFollowUpVisit = null;
                    hospitalFollowupPrompt.classList.remove('hidden');
                    this.hideFollowUpDisclaimer();
                });
                this.showFollowUpDisclaimer();
            } else if (target === notHospitalFollowUp) {
                this.hospitalFollowUpVisit = false;

                hospitalFollowupPrompt.classList.add('hidden');
                if (this.age >= 65) {
                    // add a "back" function to the back link logic stack
                    this.checkOtherPromptTypes(_ => {
                        // it is possible that the DOM elements were recreates, so we need to query for this again
                        const hospitalFollowupPrompt = this.container.querySelector('.hospital-followup-prompt');
                        this.hospitalFollowUpVisit = null;
                        hospitalFollowupPrompt.classList.remove('hidden');
                    });
                } else {
                    // add a "back" function to the back link logic stack
                    this.backLinkLogicStack.push(_ => {
                        // it is possible that the DOM elements were recreates, so we need to query for this again
                        const hospitalFollowupPrompt = this.container.querySelector('.hospital-followup-prompt');
                        this.hospitalFollowUpVisit = null;
                        hospitalFollowupPrompt.classList.remove('hidden');
                    });
                    this.showSchedulingPrompt();
                }
            }
        }));
    }

    setupMedicareAdvantagePrompt() {
        const medicareAdvantagePrompt = this.container.querySelector('.medicare-advantage-prompt');
        if (!medicareAdvantagePrompt) {
            return;
        }
        const radios = medicareAdvantagePrompt.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
            radio.addEventListener("click", ({ target }) => {
                this.medicareAdvantage = parseInt(target.value);
                if (this.medicareAdvantage) {
                    // this.medicareAdvantage = true;
                    this.container.querySelector('.medicare-advantage-prompt').classList.add('hidden');
                    this.checkOtherPromptTypes(_ => {
                        this.medicareAdvantage = null;
                        this.container.querySelector('.medicare-advantage-prompt').classList.remove('hidden');
                    });
                } else {
                    document.querySelector('.modal.medicare-advantage-modal').classList.remove('hidden');
                }
            });
        });
    }

    showFollowUpDisclaimer() {
        if (this.container.querySelector('.hospital-followup-disclaimer')) {
            const message = this.container.querySelector('.hospital-followup-disclaimer');
            const btn = this.container.querySelector('#confirm-disclaimer');
            message.classList.remove('hidden');

            btn.addEventListener('click', (e) => {
                message.classList.add('hidden');

                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(
                    this.showSchedulingPrompt(_ => {
                        message.classList.remove('hidden');
                    })
                );
            })
        }
    }

    hideFollowUpDisclaimer() {
        if (this.container.querySelector('.hospital-followup-disclaimer')) {
            const message = this.container.querySelector('.hospital-followup-disclaimer');
            message.classList.add('hidden');
        }
    }

    setupNewPatientPrompt() {
        const newPatientButton = this.container.querySelector("#new-patient-appointment");
        const establishedPatientButton = this.container.querySelector("#established-patient-appointment");

        if (newPatientButton != undefined && establishedPatientButton != undefined) {
            [newPatientButton, establishedPatientButton].forEach(button => button.addEventListener('click', ({ target }) => {
                let modal;
                if (target === newPatientButton) {
                    this.newPatient = true;
                    this.establishedPatient = false;
                    modal = document.querySelector(`.modal#${newPatientButton.dataset.modal}`);
                    if (modal) {
                        modal.classList.remove('hidden')
                    }
                } else if (target === establishedPatientButton) {
                    this.newPatient = false;
                    this.establishedPatient = true;
                }

                this.analytics._sendEvent("new_patient_prompt_click", {
                    click_text: this.newPatient ? 'No' : 'Yes',
					Schedule_Flow_Type: document.querySelector('[name="schedule-flow-type"]')?.value ?? "Providers Flow"
                });

                if (modal) {
                    return;
                }

                this.container.querySelector('.new-patient-prompt').classList.add('hidden');

                // add a "back" function to the back link logic stack
                this.checkOtherPromptTypes(_ => {
                    this.newPatient = null;
                    this.establishedPatient = null;
                    this.container.querySelector('.new-patient-prompt').classList.remove('hidden');
                });
            }));
        }
    }

    setupRuleOutQuestionsPerService() {
        const questionsElem = this.container.querySelector(`.rule-out-questions-per-service[data-service-id="${this.selectedServiceId}"]`);
        if (!questionsElem) {
            return;
        }
        const questions = questionsElem.querySelectorAll(
			".rule-out-questions-per-service .prompt"
		);
        const warningModals = questionsElem.querySelectorAll(".rule-out-questions-per-service .modal");

        // reset to initial state
        questions.forEach(q => q.classList.add('hidden'));
        warningModals.forEach(m => m.classList.add('hidden'));

        questions.forEach((prompt) => {
            const radios = prompt.querySelectorAll('input[type="radio"]');
            radios.forEach(radio => {
                radio.addEventListener("click", ({ target }) => {
                    const { value } = target;
                    if (prompt.id === "new-patient") {
                        this.analytics._sendEvent("new_patient_prompt_click", {
                            click_text: value === "1" ? "No" : "Yes",
                        });
                    }
                    if (prompt.id === "follow-up-visit") {
                        this.analytics._sendEvent(
                            "annual_physical_prompt_click",
                            {
                                click_text: value === "1" ? "Yes" : "No",
                            }
                        );
                    }
                    const modal = prompt.parentNode.querySelector(
                        `.modal#${radio.dataset.modalTrigger}`
                    );
                    const nextPrompt = prompt.parentNode.querySelector(
                        `.prompt#${radio.dataset.promptTrigger}`
                    );
                    if (modal) {
                        modal.classList.remove("hidden");
                        return;
                    }
                    if (nextPrompt) {
                        prompt.classList.add("hidden");
                        nextPrompt.classList.remove("hidden");
                        return;
                    } else {
                        prompt.classList.add('hidden');
                        this.ruledOut = false;
                        this.checkOtherPromptTypes(() => questions[0].classList.remove('hidden'));
                    }
                });
            });
        })
        
        warningModals.forEach((m, idx) => {
            m.querySelector('.material-icons.close').addEventListener('click', _ => m.classList.add('hidden'));
        })
        
        questions[0].classList.remove('hidden');
    }

    checkOtherPromptTypes(additionalFn = _ => { }) {
        if (this.veinClinicVisit !== undefined && this.veinClinicVisit === null) {
            // show the vein clinic prompt
            this.container.querySelector('.vein-clinic-prompt').classList.remove('hidden');

            // add a "back" function to the back link logic stack
            this.backLinkLogicStack.push(_ => {
                additionalFn();
                this.container.querySelector('.vein-clinic-prompt').classList.add('hidden');
            });
            return;
        }
        if (this.fullBodySkinExamVisit !== undefined && this.fullBodySkinExamVisit === null) {
            // show the vein clinic prompt
            this.container.querySelector('.full-body-skin-exam-prompt').classList.remove('hidden');

            // add a "back" function to the back link logic stack
            this.backLinkLogicStack.push(_ => {
                additionalFn();
                this.container.querySelector('.full-body-skin-exam-prompt').classList.add('hidden');
            });
            return;
        }
        if (this.veinClinicVisit === true || this.fullBodySkinExamVisit === true) {
            // skip all other prompts
            this.showSchedulingPrompt();
            return;
        } else {
            if (this.container.querySelector(`.select-service-prompt input[data-service-id="${this.selectedServiceId}"]`) && this.followUpVisit === null) {
                this.container.querySelector('.follow-up-visit-prompt').classList.remove('hidden');

                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                    this.container.querySelector('.follow-up-visit-prompt').classList.add('hidden');
                });
            } else if (this.container.querySelector('.hospital-followup-prompt') && this.establishedPatient && !this.followUpVisit && this.hospitalFollowUpVisit === null) {
                this.container.querySelector('.hospital-followup-prompt').classList.remove('hidden');

                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                    this.container.querySelector('.hospital-followup-prompt').classList.add('hidden');
                });
            } else if (this.container.querySelector('.medicare-advantage-prompt') && this.age >= 65 && this.followUpVisit != null && this.medicareAdvantage == null) {
                this.container.querySelector('.medicare-advantage-prompt').classList.remove('hidden');

                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                    this.container.querySelector('.medicare-advantage-prompt').classList.add('hidden');
                });
                this.setupMedicareAdvantagePrompt();
            } else if (this.container.querySelector('.ask-if-pregnant-prompt') && (!this.establishedPatient || this.establishedPatient && !this.followUpVisit)) {
                this.container.querySelector('.ask-if-pregnant-prompt').classList.remove('hidden');

                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                    this.container.querySelector('.ask-if-pregnant-prompt').classList.add('hidden');
                });
                this.setupPregnancyPrompt();
            } else if (this.container.querySelector(`.rule-out-questions-per-service[data-service-id="${this.selectedServiceId}"]`) && this.ruledOut == null) {
                this.container.querySelector(`.rule-out-questions-per-service[data-service-id="${this.selectedServiceId}"]`).classList.remove('hidden');

                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                    this.container.querySelector(`.rule-out-questions-per-service[data-service-id="${this.selectedServiceId}"]`).classList.add('hidden');
                });
                
                this.setupRuleOutQuestionsPerService();
            } else if (this.container.querySelector(`.supportedReason[data-service-id="${this.selectedServiceId}"]${this.newPatient ? `[data-new-patients="1"]` : `[data-established-patients="1"]`}`)) {
                this.container.querySelectorAll(`.supportedReason[data-service-id="${this.selectedServiceId}"]${this.newPatient ? `[data-established-patients="1"]` : `[data-new-patients="1"]`}`).forEach((reason) => reason.classList.add('hidden'));
                this.container.querySelectorAll(`.supportedReason[data-service-id="${this.selectedServiceId}"]${this.newPatient ? `[data-new-patients="1"]` : `[data-established-patients="1"]`}`).forEach((reason) => reason.classList.remove('hidden'));
                this.container.querySelector('.reason-for-visit-prompt').classList.remove('hidden');
                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                    this.container.querySelectorAll(`.supportedReason[data-service-id="${this.selectedServiceId}"]`).forEach((reason) => reason.classList.add('hidden'));
                    this.container.querySelector('.reason-for-visit-prompt').classList.add('hidden');
                });
                this.setupServiceReasonForVisitPrompt();
            } else {
                // add a "back" function to the back link logic stack
                this.backLinkLogicStack.push(_ => {
                    additionalFn();
                });
                this.showSchedulingPrompt();
            }
        }
    }

    showSchedulingPrompt() {
        // add a "back" function to the back link logic stack
        // record current HTML for the ".appointments-module" element since the SelectAppointment class will overwrite it with the calendar widget
        // on the "back" button, restore the HTML
        this.backLinkLogicStack.push((prevAppointmentsModuleHTML => {
            return _ => {
                document.querySelector('.appointments-module').innerHTML = prevAppointmentsModuleHTML;
                this.setupOnlineSchedulingModule(false);
                this.backLinkDomElement.click();
            }
        })(document.querySelector('.appointments-module').innerHTML));

        // this.container.querySelector(".select-appointment-content").classList.remove('hidden');
        let month = document.querySelector(
            "input[name='date_of_birth_month']"
        );
        let day = document.querySelector(
            "input[name='date_of_birth_day']"
        );
        let year = document.querySelector(
            "input[name='date_of_birth_year']"
        );
        let dob = year.value + '-' + month.value + '-' + day.value;
        this.selectAppointment = new SelectAppointment(this.physicianId, 5, this.selectedServiceId, this.newPatient, this.establishedPatient, this.followUpVisit, null, this.veinClinicVisit, false, this.fullBodySkinExamVisit, day.value, month.value, year.value, dob, this.reasonForVisitId);
    }

    setupFollowUpPrompt() {
        const yesFollowupVisitButton = this.container.querySelector("#follow-up-visit");
        const notFollowupVisitButton = this.container.querySelector("#not-follow-up-visit");

        if (yesFollowupVisitButton != undefined && notFollowupVisitButton != undefined) {
            [yesFollowupVisitButton, notFollowupVisitButton].forEach(button => button.addEventListener('click', ({ target }) => {
                if (target === yesFollowupVisitButton) {
                    this.followUpVisit = true;
                    document.querySelector('.medicaid-modal').classList.remove('hidden');
                    return;
                } else if (target === notFollowupVisitButton) {
                    this.followUpVisit = false;
                }

                this.analytics._sendEvent('annual_physical_prompt_click', {
                    'click_text': this.followUpVisit ? 'Yes' : 'No'
                });

                this.container.querySelector('.follow-up-visit-prompt').classList.add('hidden');
                // add a "back" function to the back link logic stack
                this.checkOtherPromptTypes(_ => {
                    this.followUpVisit = null;
                    this.container.querySelector('.follow-up-visit-prompt').classList.remove('hidden');
                });
            }));
        }
    }

    setupVeinClinicPrompt() {
        const yesVeinClinicVisitButton = this.container.querySelector("#vein-clinic-visit");
        const notVeinClinicVisitButton = this.container.querySelector("#not-vein-clinic-visit");

        if (yesVeinClinicVisitButton != undefined && notVeinClinicVisitButton != undefined) {
            this.veinClinicVisit = null;
            [yesVeinClinicVisitButton, notVeinClinicVisitButton].forEach(button => button.addEventListener('click', ({ target }) => {
                if (target === yesVeinClinicVisitButton) {
                    this.veinClinicVisit = true;
                } else if (target === notVeinClinicVisitButton) {
                    this.veinClinicVisit = false;
                }

                this.container.querySelector('.vein-clinic-prompt').classList.add('hidden');
                // add a "back" function to the back link logic stack
                this.checkOtherPromptTypes(_ => {
                    this.container.querySelector('.vein-clinic-prompt').classList.remove('hidden');
                });
            }));
        }
    }

    setupFullBodySkinExamPrompt() {
        const yesFullBodySkinExamVisitButton = this.container.querySelector("#full-body-skin-exam-visit");
        const notFullBodySkinExamVisitButton = this.container.querySelector("#not-full-body-skin-exam-visit");

        if (yesFullBodySkinExamVisitButton != undefined && notFullBodySkinExamVisitButton != undefined) {
            this.fullBodySkinExamVisit = null;
            [yesFullBodySkinExamVisitButton, notFullBodySkinExamVisitButton].forEach(button => button.addEventListener('click', ({ target }) => {
                if (target === yesFullBodySkinExamVisitButton) {
                    this.fullBodySkinExamVisit = true;
                } else if (target === notFullBodySkinExamVisitButton) {
                    this.fullBodySkinExamVisit = false;
                }

                this.container.querySelector('.full-body-skin-exam-prompt').classList.add('hidden');
                // add a "back" function to the back link logic stack
                this.checkOtherPromptTypes(_ => {
                    this.container.querySelector('.full-body-skin-exam-prompt').classList.remove('hidden');
                });
            }));
        }
    }

    jumpToRatings() {
        const count = document.querySelector('.stars .count');
        const ratingsContainer = document.querySelector('.ratings-container');

        count.addEventListener('click', (e) => {
            if (window.innerWidth >= 800) {
                ratingsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                ratingsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    setupDetailsPartsANavigation() {
        [
            this.navItemGeneralInfo,
            this.navItemVideo,
            this.navItemHospitalAffiliations
        ].forEach(navItem => {
            if (!navItem) {
                return;
            }
            navItem.addEventListener("click", this.detailsANavigationHandler.bind(this));
            navItem.addEventListener("keyup", this.detailsANavigationHandler.bind(this));
        });
    }

    setupDetailsPartsBNavigation() {
        [
            this.navItemEducation,
            this.navItemEditorial,
            this.navItemPublications,
            this.navItemResearch,
        ].forEach(navItem => {
            if (!navItem) {
                return;
            }
            navItem.addEventListener("click", this.detailsBNavigationHandler.bind(this));
            navItem.addEventListener("keyup", this.detailsBNavigationHandler.bind(this));

            if (navItem.classList.contains('active')) {
                navItem.click();
            }
        });
    }

    detailsANavigationHandler(e) {
        // skip if a non-enter key was pressed
        if (e.keyCode !== undefined && e.keyCode !== 13) {
            return;
        }

        let target = e.target;

        this.navItemGeneralInfo && this.navItemGeneralInfo.classList.remove('active');
        this.navItemVideo && this.navItemVideo.classList.remove('active');
        this.navItemHospitalAffiliations && this.navItemHospitalAffiliations.classList.remove('active');

        this.detailsGeneralInfo && this.detailsGeneralInfo.classList.remove('active');
        this.detailsVideo && this.detailsVideo.classList.remove('active');
        this.detailsHospitalAffiliations && this.detailsHospitalAffiliations.classList.remove('active');

        if (target.classList.contains("general-info")) {
            this.navItemGeneralInfo && this.navItemGeneralInfo.classList.add('active');
            this.detailsGeneralInfo && this.detailsGeneralInfo.classList.add('active');
        }

        if (target.classList.contains("video")) {
            this.navItemVideo && this.navItemVideo.classList.add('active');
            this.detailsVideo && this.detailsVideo.classList.add('active');

        } else {
            if (this.player) {
                this.player.pauseVideo();
            }
        }

        if (target.classList.contains("hospital-affiliations")) {
            this.detailsHospitalAffiliations && this.detailsHospitalAffiliations.classList.add('active');
            this.navItemHospitalAffiliations && this.navItemHospitalAffiliations.classList.add('active');
        }
    }

    detailsBNavigationHandler(e) {
        // skip if a non-enter key was pressed
        if (e.keyCode !== undefined && e.keyCode !== 13) {
            return;
        }

        let target = e.target;

        this.navItemEducation && this.navItemEducation.classList.remove('active');
        this.navItemEditorial && this.navItemEditorial.classList.remove('active');
        this.navItemPublications && this.navItemPublications.classList.remove('active');
        this.navItemResearch && this.navItemResearch.classList.remove('active');

        this.detailsEducation && this.detailsEducation.classList.remove('active');
        this.detailsEditorial && this.detailsEditorial.classList.remove('active');
        this.detailsPublications && this.detailsPublications.classList.remove('active');
        this.detailsResearch && this.detailsResearch.classList.remove('active');

        if (target.classList.contains("education")) {
            this.navItemEducation && this.navItemEducation.classList.add('active');
            this.detailsEducation && this.detailsEducation.classList.add('active');
        }
        if (target.classList.contains("editorial")) {
            this.navItemEditorial && this.navItemEditorial.classList.add('active');
            this.detailsEditorial && this.detailsEditorial.classList.add('active');
        }
        if (target.classList.contains("publications")) {
            this.detailsPublications && this.detailsPublications.classList.add('active');
            this.navItemPublications && this.navItemPublications.classList.add('active');
        }
        if (target.classList.contains("research")) {
            this.detailsResearch && this.detailsResearch.classList.add('active');
            this.navItemResearch && this.navItemResearch.classList.add('active');
        }
    }

    setupEditorialShowLessShowMore() {
        if (!document.querySelector(".editorial .expand.show-more")) {
            return;
        }
        document.querySelector(".editorial .expand.show-more").addEventListener("click", _ => {
            document.querySelector(".editorial.physician-contributions").classList.remove("show-less");
            document.querySelector(".editorial .expand.show-more").classList.add("hidden");
            document.querySelector(".editorial .expand.show-less").classList.remove("hidden");
        });
        document.querySelector(".editorial .expand.show-less").addEventListener("click", _ => {
            document.querySelector(".editorial.physician-contributions").classList.add("show-less");
            document.querySelector(".editorial .expand.show-more").classList.remove("hidden");
            document.querySelector(".editorial .expand.show-less").classList.add("hidden");
        });
    }

    setupCommentsShowLessShowMore() {
        if (!document.querySelector(".comments-container .expand.show-more")) {
            return;
        }
        document.querySelector(".comments-container .expand.show-more").addEventListener("click", _ => {
            document.querySelector(".comments-container .comments").classList.remove("show-less");
            document.querySelector(".comments-container .expand.show-more").classList.add("hidden");
            document.querySelector(".comments-container .expand.show-less").classList.remove("hidden");
        });
        document.querySelector(".comments-container .expand.show-less").addEventListener("click", _ => {
            document.querySelector(".comments-container .comments").classList.add("show-less");
            document.querySelector(".comments-container .expand.show-more").classList.remove("hidden");
            document.querySelector(".comments-container .expand.show-less").classList.add("hidden");
        });
    }

    setupDobFieldListeners() {
        if (!document.querySelector("#dobContainer")) {
            return;
        }
        this.date_of_birth_month = document.querySelector(
            "input[name='date_of_birth_month']"
        );
        this.date_of_birth_day = document.querySelector(
            "input[name='date_of_birth_day']"
        );
        this.date_of_birth_year = document.querySelector(
            "input[name='date_of_birth_year']"
        );
        this.date_of_birth_month.addEventListener("input", ({ target }) => {
            target.value = target.value.replace(/\D/g, "");
            this.validateForm();

            // skip to the next field
            if (this.date_of_birth_month.value.length == 2) {
                this.date_of_birth_day.select();
            }
        });

        this.date_of_birth_day.addEventListener("input", ({ target }) => {
            target.value = target.value.replace(/\D/g, "");
            this.validateForm();
            // skip to the next field
            if (this.date_of_birth_day.value.length == 2) {
                this.date_of_birth_year.select();
            }
        });

        this.date_of_birth_year.addEventListener("input", ({ target }) => {
            target.value = target.value.replace(/\D/g, "");
            this.validateForm();
        });

        [this.date_of_birth_month, this.date_of_birth_day, this.date_of_birth_year].forEach((field) =>
            field.addEventListener("blur", ({ target }) => {
                target.dataset.modified = "1";
                this.validateForm();
            })
        );

        const patientDobForm = document.getElementById('patientDob');
        patientDobForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.checkAge();
            document.querySelector('.dobPhysicians').classList.add('hidden');
            this.backLinkDomElement.classList.remove('hidden');
            this.setupSelectServicePrompt();
        });

        const nextButton = patientDobForm.querySelector('#proceedContainer button');
        if (nextButton) {
            nextButton.addEventListener("click", () => {
                this.analytics._sendEvent("schedule_appointment_start", {
                    Schedule_Flow_Type: document.querySelector('[name="schedule-flow-type"]')?.value ?? "",
                });
            });
        }
    }

    checkAge() {
        this.maximumAge = document.querySelector(".maximum-age-phycician");
        this.minimumAge = document.querySelector(".minimum-age-phycician");

        this.age = moment().diff(this.date_of_birth_year.value + '-' + this.date_of_birth_month.value + '-' + this.date_of_birth_day.value, 'years');

        if (this.minimumAge.value > this.age || this.maximumAge.value < this.age) {
            document.querySelector('.age-restriction-physician').classList.remove('hidden');
        }
    }

    validateForm() {
        const nextButton = document.querySelector("#proceedContainer button");
        let dateEntered = moment(
            `${this.date_of_birth_month.value.padStart(
                2,
                "0"
            )}/${this.date_of_birth_day.value.padStart(
                2,
                "0"
            )}/${this.date_of_birth_year.value.padStart(4, "0")}`
        ).unix();
        // this gets the current date plus 9 months to allow parents to use their childs due date as a DOB
        let currentDate = Math.floor(new Date().getTime() / 1000) + 23670000;
        let validDate =
            dateEntered < currentDate &&
            parseInt(this.date_of_birth_year.value) < new Date().getFullYear() + 2 &&
            this.date_of_birth_year.value.length === 4 &&
            moment(
                `${this.date_of_birth_month.value.padStart(
                    2,
                    "0"
                )}/${this.date_of_birth_day.value.padStart(
                    2,
                    "0"
                )}/${this.date_of_birth_year.value.padStart(4, "0")}`,
                "MM/DD/YYYY",
                true
            ).isValid();

        if (
            this.date_of_birth_month.dataset.modified === "1" &&
            this.date_of_birth_day.dataset.modified === "1" &&
            this.date_of_birth_year.dataset.modified === "1" &&
            !validDate
        ) {
            this.date_of_birth_month
                .closest(".mdc-text-field")
                .classList.add("mdc-text-field-error");
            this.date_of_birth_day
                .closest(".mdc-text-field")
                .classList.add("mdc-text-field-error");
            this.date_of_birth_year
                .closest(".mdc-text-field")
                .classList.add("mdc-text-field-error");
        } else {
            this.date_of_birth_month
                .closest(".mdc-text-field")
                .classList.remove("mdc-text-field-error");
            this.date_of_birth_day
                .closest(".mdc-text-field")
                .classList.remove("mdc-text-field-error");
            this.date_of_birth_year
                .closest(".mdc-text-field")
                .classList.remove("mdc-text-field-error");
        }
        nextButton.disabled = !validDate;
    }
}
